import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('gc_token');
    const storedUser = localStorage.getItem('gc_user');
    if (storedToken && storedUser) {
      setToken(storedToken);
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  function login(userData, authToken) {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem('gc_token', authToken);
    localStorage.setItem('gc_user', JSON.stringify(userData));
  }

  function logout() {
    setUser(null);
    setToken(null);
    localStorage.removeItem('gc_token');
    localStorage.removeItem('gc_user');
  }

  function updateUser(userData) {
    setUser(userData);
    localStorage.setItem('gc_user', JSON.stringify(userData));
  }

  const isAdmin = user?.level === 'admin';
  const isLoggedIn = !!token;
  const isFirstTime = user?.firstTime === true;

  return (
    <AuthContext.Provider value={{ user, token, loading, isAdmin, isLoggedIn, isFirstTime, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export default AuthContext;
